<div class="as-label-main-container">
  @if(label.message){
  <div
    (click)="label.showMore ? showMore() : null"
    [ngClass]="{
      'as-label-container-blue': smart,
      'as-label-container-red': !smart,
      'as-pointer': label.clickable
    }"
  >
    <p [class]="smart ? 'as-text-blue' : 'as-text-red'" class="as-label-text">
      {{ label.message }}
      @if(label.showMore && isSuperMix){ -
      <span class="as-font-underline">Ver más</span>
      }
    </p>
  </div>
  } @if(options.showDiscount && discount> 20 && smart){
  <div class="as-label-container-red">
    <p class="as-text-red as-label-text">-{{ discount }}%</p>
  </div>
  }
</div>
